import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Icon from '@klv/atoms/icon';
import { generateClassName } from '@klv/shared/utils/functions';

import DemoForm from './form';
import DemoSuccess from './success';
import FormWrapper from '../wrapper';
import HubSpotDemoForm from './hubSpotDemoForm';
import * as styles from '../styles/forms.module.scss';

import type { IDemoFormIndex } from '../types';

const Demo = ({
  backgroundColor = 'light',
  bodyCopy = '',
  formState,
  headline = '',
  inHero = false,
  setFormState,
  settings,
  templateName,
  demoType,
}: IDemoFormIndex) => {
  const { t } = useTranslation();
  const [success, setSuccess] = useState(false);
  const colorVariant = 'light';

  let plaintextHeadline = t('organisms_forms_demo_headline');
  let body = t('organisms_forms_demo_body');

  if (inHero) {
    plaintextHeadline = t('organisms_forms_demo_headlineEmbedded');
    body = bodyCopy;
  }

  if (success) {
    return (
      <DemoSuccess
        backgroundColor={backgroundColor}
        colorVariant={colorVariant}
        templateName={templateName}
      />
    );
  }

  return (
    <FormWrapper
      backgroundColor={backgroundColor}
      inHero={inHero}
      logo={<Icon className={styles.logo} iconName="Logo" fillColor="currentColor" role="img" aria-label="Klaviyo Logo" />}
    >
      <header>
        <h2 
          className={generateClassName(['h2', styles.headline])}
          dangerouslySetInnerHTML={headline ? { __html: headline } : undefined}
        >
          {headline ? null : plaintextHeadline}
        </h2>
        {body && (
          <p 
            className={generateClassName(['p1', styles.marginBottom25])}
            dangerouslySetInnerHTML={{ __html: body }}
          />
        )}
      </header>
      <div className="formSmall" >{t('organisms_forms_demo_allRequired')}</div>
      {demoType === 'demoHubSpot' ? (
        <HubSpotDemoForm
          backgroundColor={backgroundColor}
          setSuccess={setSuccess} 
          settings={settings || {}} 
          />) : (
        <DemoForm
          backgroundColor={backgroundColor}
          formState={formState}
          setFormState={setFormState}
          setSuccess={setSuccess}
          settings={settings}
          templateName={templateName}
        />
      )}
  
    </FormWrapper>
  );
};

export default Demo;
